import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { getTypeName, LinqNode, LinqsetNode, NODE_TYPE } from '../../common/linqset-model';

// adds a role or system (existing, or new by name) to several selected nodes at once
@Component({
    selector: 'select-node-dialog',
    templateUrl: 'select-node-dialog.html',
    styles: ['.message { margin: 4px 0 0; font-size: 13px; color: var(--slate); }'],
    standalone: false
})
export class SelectNodeDialogComponent {
    selectedNode:LinqsetNode
    nodeName:string = ''
    typeName:string
    article:string

    constructor(public dialogRef: MatDialogRef<SelectNodeDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data:{nodes:LinqsetNode[], numNodes:number, type?:NODE_TYPE}) {
        this.typeName = (data.type && getTypeName(data.type)?.toLowerCase()) || 'node'
        this.article = /^[aeiou]/.test(this.typeName) ? 'an' : 'a'
    }

    // picked from the list
    onChange(event:{node:LinqNode, name:string}) {
        if (event.node) {
            this.selectedNode = event.node as LinqsetNode
            this.nodeName = event.node.name
        }
    }

    // typed; a name that matches an existing node uses that node rather than creating a copy
    onNameTyped(event:{name:string, existingNode?:LinqNode}) {
        this.nodeName = event.name || ''
        this.selectedNode = event.existingNode as LinqsetNode
    }

    canSave() {
        return !!this.selectedNode || this.nodeName.trim().length > 0
    }

    getMessage() {
        const targets = `${this.data.numNodes} selected node${this.data.numNodes === 1 ? '' : 's'}`
        if (this.selectedNode) return `${this.selectedNode.name} will be connected to the ${targets}.`
        if (this.nodeName.trim()) return `A new ${this.typeName} called ${this.nodeName.trim()} will be created and connected to the ${targets}.`
        return `Choose an existing ${this.typeName}, or type a name to create a new one.`
    }

    onSaveClick(): void {
        if (this.selectedNode) this.dialogRef.close(this.selectedNode)
        else if (this.nodeName.trim()) this.dialogRef.close(this.nodeName.trim())
    }
}
